import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  leftAction?: React.ReactNode;
  rightAction?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, leftAction, rightAction }) => {
  return (
    <header className="page-header">
      <div className="page-header-left">{leftAction || <div style={{ width: 36 }} />}</div>
      <h1 className="page-header-title">{title}</h1>
      <div className="page-header-right">{rightAction || <div style={{ width: 36 }} />}</div>
    </header>
  );
};
